import headers from './components/headers.vue'
import footers from './components/footers.vue'
import hero from './components/hero.vue'
import breadcrumb from './components/breadcrumb.vue'
import mainswiper from './components/mainswiper.vue'
import voiceswiper from './components/voiceswiper.vue'
import carousel from './components/carousel.vue'
import gallery from './components/gallery.vue'
import itemslider from './components/itemslider.vue'
import swiper from './components/swiper.vue'
import cookie from './components/cookie.vue'
import sidebnr from './components/sidebnr.vue'

import { createApp } from 'vue'

export default function partials(){
  return new Promise((resolve) => {
    const app = createApp({
      components: {
        headers: headers,
        footers: footers,
        hero: hero,
        breadcrumb: breadcrumb,
        mainswiper: mainswiper,
        voiceswiper: voiceswiper,
        carousel: carousel,
        gallery: gallery,
        itemslider: itemslider,
        swiper: swiper,
        sidebnr: sidebnr,
        cookie: cookie,
      },
      data() {
        return {
          color: '#FFF',
          text: 'ABC',
        }
      },
    });
    
    // Vue.jsを#appにマウント
    app.mount('#app');
    resolve();
  });
}
